/* eslint-disable no-param-reassign */
import Vue from 'vue';
import DeviceEvents from '@/resources/device_events';
import PaginatedList from './mixins/paginated-list';

const DEFAULT_STATE = {
  activeEvent: {}
};

export default {
  namespaced: true,
  ...PaginatedList(
    DeviceEvents,
    {
      state: DEFAULT_STATE,
      mutations: {
        setActiveEvent(state, event) {
          Vue.set(state, 'activeEvent', event);
        },
        resetEvent(state) {
          state.activeEvent = null;
        }
      },
      getters: {
        getActiveEvent: state => state.activeEvent
      }
    },
    'deviceEvents'
  )
};
